import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import { icon as iconStyles, infoBoxContainer } from "./styles.module.scss"
import Icon from "../../layout/icon"
import { BodyText, InlineText } from "../../Typography/Typography"
import Stack from "../../layout/Stack/Stack"

const InfoBox = ({ children: [title, body], icon }) => (
  <div className={classNames(infoBoxContainer)}>
    <InlineText brand className={classNames(iconStyles)}>
      <Icon icon={icon} />
    </InlineText>
    <Stack>
      <BodyText smSmall semibold>
        {title}
      </BodyText>
      <BodyText smSmall>{body}</BodyText>
    </Stack>
  </div>
)

InfoBox.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.shape({
    iconName: PropTypes.string,
  }).isRequired,
}

export default InfoBox
